import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { Form } from "./Form";
import { Table } from "./Table";
import { ICountryMastDropdown } from "../../../models/IDropdown";

export interface IState {
    state_ID?: number,
    country_ID?: number,
    country?: ICountryMastDropdown,
    state_Name?: string,
    country_Name?: string,
    description?: string,
    zoneID?: number
}
export const EmptyState: IState = {
    state_ID: undefined,
    country_ID: 0,
    country: { country_ID: 0, country_Name: "" },
    state_Name: "",
    description: ""
}

export interface IModel {
    open: boolean,
    singleData: IState
}

export const State = ({ setTab }: { setTab: (tab: number) => void }) => {

    const [modal, setModal] = useState({ singleData: EmptyState, open: false } as IModel);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: EmptyState, open: false })
    };

    return (
        <>
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>
            <Table setTab={setTab} setModal={setModal} toast={toast} reload={reload}></Table>
            <Toast ref={toast} />
        </>
    );
}
